import React, {useEffect, useState} from 'react';
import {Table} from 'antd';
import {Arguments} from '../common/Arguments';
import {RealtimeGetMethod} from '../common/ApiMethod';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';

export default function SocietyInformationAudit(props) {
	const [auditData, setAuditData] = useState([]);
	const getApi = Arguments.host + '/society_organization/society/api!societyInformation.do';

	useEffect(() => {
		RealtimeGetMethod(getApi).then(allData => setAuditData(allData?.filter(data => checkData(data))));
	}, [getApi]);

	const checkData = (data) => {
		// 逻辑：换届时间 + 换届年限 - 当前时间大于 0 并且小于 12 个月，如果小于 0 说明过期未换届
		const organizationTermDate = data.organizationTermDate;
		const organizationOneTermYear = data.organizationOneTermYear;
		if (organizationTermDate && organizationOneTermYear) {
			const currentDate = new Date();
			const termDate = new Date(organizationTermDate);
			const fiveYearLater = new Date(termDate);
			fiveYearLater.setFullYear(termDate.getFullYear() + parseInt(organizationOneTermYear));
			const diffInMs = fiveYearLater.getTime() - currentDate.getTime();
			const diffInMonths = diffInMs / (1000 * 60 * 60 * 24 * 30);
			return diffInMonths <= 12;
		} else {
			return false;
		}
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '社会组织名称',
			dataIndex: 'organizationName',
			width: 300,
		},
		{
			title: '类别',
			dataIndex: 'organizationType',
			width: 120,
		},
		{
			title: '发起人/发起单位',
			dataIndex: 'establishUnit',
			width: 200,
		},
		{
			title: '成立时间',
			dataIndex: 'organizationEstablishDate',
			width: 120,
		},
		{
			title: '换届时间',
			dataIndex: 'organizationTermDate',
			width: 120,
			sorter: (a, b) => a.organizationTermDate.localeCompare(b.organizationTermDate),
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '每届年限',
			dataIndex: 'organizationOneTermYear',
			width: 120,
		},
		{
			title: '当前届数',
			dataIndex: 'organizationCurrentTerm',
			width: 120,
		},
		{
			title: '当前状态',
			dataIndex: 'status',
			width: 120,
		},
	];
	const indexDataSource = auditData?.map((data, index) => ({showIndex: index + 1, ...data}));

	const newData = indexDataSource?.map(
		(
			{
				showIndex,
				organizationName,
				organizationType,
				organizationCode,
				establishUnit,
				organizationEstablishMoney,
				organizationBank,
				organizationBankAccount,
				organizationEvaluationGrade,
				organizationPublicWx,
				organizationSubdiscipline,
				organizationWorkPeopleCount,
				organizationEstablishDate,
				organizationTermDate,
				organizationOneTermYear,
				organizationCurrentTerm,
				status,
				organizationMemo,
			},
		) => (
			{
				'序号': showIndex,
				'社会组织名称': organizationName,
				'类别': organizationType,
				'组织机构代码': organizationCode,
				'发起人/发起单位': establishUnit,
				'开办资金（万元）': organizationEstablishMoney,
				'开户行名称': organizationBank,
				'开户行账号': organizationBankAccount,
				'评估等级': organizationEvaluationGrade,
				'公众号': organizationPublicWx,
				'学科类别': organizationSubdiscipline,
				'从业人数': organizationWorkPeopleCount,
				'成立时间': organizationEstablishDate,
				'换届时间': organizationTermDate,
				'每届年限': organizationOneTermYear,
				'当前届数': organizationCurrentTerm,
				'当前状态': status,
				'学会简介': organizationMemo,
			}
		),
	);

	return (
		<>
			<ExportToExcel tableData={newData}/>
			<Table dataSource={indexDataSource} columns={columns}/>
		</>
	);
}

